/**
 * Which side of the registration a role object stands for.
 *
 * The session and context carry the role as a registration-type object; the
 * start-step logic reads it as `'player' | 'team'`. Matching is by id against
 * the two known types, so the answer is null until BOTH the role and the types
 * have loaded — a role that cannot be placed yet is reported as unknown rather
 * than guessed, because guessing wrong puts the wrong team shape in front of the
 * wrong reader.
 */

import type { StartRole } from './types'

interface IdOnly {
  id?: string | number | null
}

export const startRoleFor = (
  role: IdOnly | null | undefined,
  playerType: IdOnly | null | undefined,
  teamOfficialType: IdOnly | null | undefined
): StartRole | null => {
  if (!role?.id) {
    return null
  }
  if (playerType?.id != null && role.id === playerType.id) {
    return 'player'
  }
  if (teamOfficialType?.id != null && role.id === teamOfficialType.id) {
    return 'team'
  }
  return null
}
